import { asArray, filterArray } from '../../utils/arrayData.js';
import Form, {
    Label, SimpleItem, GroupItem,
    RequiredRule
} from '../../components/BootstrapForm';
import { Popup, Position, ScrollView, Box, BoxItem as Item, Button } from '../../components/BootstrapControls';
// Responsive SCSS import
import './carisatis-responsive.scss';
import DataGrid, {
    Column, LoadPanel,
    Scrolling, Selection, Lookup,
} from '../../components/BootstrapDataGrid';
import { Redirect } from "react-router-dom";
import Axios from "../../api/axios";
import notify from '../../utils/notifyUtil';
import React, { useState, useEffect, useRef, useCallback, useMemo, Suspense } from 'react';
import Dict from "../../messages.js";
import * as glb from "../../globals.js";
import * as utl from "../../utils/utils.js";
import { emitCariSync, subscribeCariSync } from "../../utils/cariSyncBus.js";
import MasterKayitGerekliUyari, { cariKayitliMi } from '../../components/cari/MasterKayitGerekliUyari.js';
import { getCached, getCachedOrFetch, setCached, clearCached, carRefCacheKey, casRefCacheKey } from '../../utils/requestCache.js';
import { gridHeightByRowCount, gridMaxHeightForRows, sortSatisRowsByRefDesc } from '../../utils/gridAutoHeight.js';
import { normalizeKeysToUpper, normalizeListToUpper } from '../../utils/dbKeyNormalize.js';
import { shouldMountSalesPanel } from '../../utils/cariBundleReadModel.js';
import { canDeleteByOwner, FOREIGN_DELETE_MESSAGE, satisIsYapanRef } from '../../utils/ownRecordDelete.js';
import { allowedSatisYapanRefs, canAssignSatisYapan } from '../../utils/cariOwnerAccess.js';
import { ensureEntityBundleCached } from '../../services/syncService';
import { injectQuickDatePresets } from '../../utils/dateQuickPresets';
import { enableGridWheelOuterScroll } from '../../utils/gridWheelOuterScroll.js';
import { getIslemStTur, isKnownCasTip, isEkimCasTip } from '../../utils/satisTipiSabit.js';
import LoadingElapsed from '../../components/LoadingElapsed';
import {
    enrichMetaFormItems,
    latestMetaFormRef,
    META_FORM_EDITOR_CLASS,
    META_FORM_FIELD_CLASS,
} from '../../utils/metaFormGelis.js';
import {
    satisTuruItemsForCasTip,
    satisPaketItemsForCasTip,
    satisTipiItems,
    allSatisTuruLookupItems,
    allSatisPaketLookupItems,
} from '../../utils/satisTipiLookups.js';
import { isUcretsizRevizyonSatis, normalizeUcretsizRevizyonPayload } from '../../utils/revizyonSatis.js';
import { shouldOfferSatisSablon } from '../../utils/islemsablonLkp';

const LazyIslemPanel = React.lazy(() => import('../../components/cari/IslemPanel'));
const LazyParaPanel = React.lazy(() => import('../../components/cari/ParaPanel'));

// Basit hata yakalama için ErrorBoundary ekliyoruz, component kaybolma sebebi hata mı görmek için.
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }
    static getDerivedStateFromError(error) { return { hasError: true, error }; }
    componentDidCatch(error, info) { /* production'da sessiz; gerekirse Sentry entegrasyonu eklenebilir */ }
    render() {
        if (this.state.hasError) {
            return <div style={{ padding: 8, border: '1px solid #d32f2f', background: '#ffebee', color: '#b71c1c' }}>
                <b>Görünüm hata verdi.</b>
                <div style={{ fontSize: 12, whiteSpace: 'pre-wrap' }}>{String(this.state.error)}</div>
            </div>;
        }
        return this.props.children;
    }
}

function sameCalendarDay(a, b) {
    if (a == null && b == null) return true;
    if (a == null || b == null) return false;
    const da = new Date(a);
    const db = new Date(b);
    if (isNaN(da.getTime()) || isNaN(db.getTime())) return String(a) === String(b);
    return da.getFullYear() === db.getFullYear()
        && da.getMonth() === db.getMonth()
        && da.getDate() === db.getDate();
}

export default function Carisatis(props) {
    const handleDateBoxOpened = (e) => {
        injectQuickDatePresets(e?.component);
    };

    // eslint-disable-next-line no-unused-vars
    const [actionType, setActionType] = useState(0);
    const [formShow, setFormShow] = useState(true);
    const [satisReadOnly, setSatisReadOnly] = useState(true);
    // resimReadOnly ve islemReadOnly kaldırıldı - artık her zaman bağımsız girilebilir
    const [satistipi, setSatistipi] = useState(-1);
    const [satistipigrubu, setSatistipigrubu] = useState(-1);
    const [activeSatis, setActiveSatis] = useState({ CAS_REF: -1 });
    const [formGelisler, setFormGelisler] = useState([]);
    const metaFormItems = useMemo(() => enrichMetaFormItems(formGelisler), [formGelisler]);
    const showMetaFormSelect = metaFormItems.length > 0;

    useEffect(() => {
        const carRef = props.ops?.CAR_REF;
        const fromOps = props.ops?.FORM_GELISLER;
        if (Array.isArray(fromOps) && fromOps.length) {
            setFormGelisler(fromOps);
            return;
        }
        if (!cariKayitliMi(carRef)) {
            setFormGelisler([]);
            return;
        }
        let cancelled = false;
        Axios.get(`${process.env.REACT_APP_BACKEND_SERVER}CARI_KART/formGelisler?CAR_REF=${carRef}`)
            .then((res) => {
                if (cancelled) return;
                setFormGelisler(Array.isArray(res.data) ? res.data : []);
            })
            .catch(() => {
                if (!cancelled) setFormGelisler([]);
            });
        return () => { cancelled = true; };
    }, [props.ops?.CAR_REF, props.ops?.FORM_GELISLER, props.refreshToken]);

    const syncLookupsFromCasTip = useCallback((casTip) => {
        if (!isKnownCasTip(casTip)) {
            setSatistipi(-1);
            setSatistipigrubu(-1);
            return;
        }
        const tip = Number(casTip);
        setSatistipi(tip);
        setSatistipigrubu(getIslemStTur(tip));
    }, []);

    const satisTuruFormItems = React.useMemo(() => satisTuruItemsForCasTip(satistipi), [satistipi]);
    const satisPaketFormItems = React.useMemo(() => satisPaketItemsForCasTip(satistipi), [satistipi]);
    const satisTipiGridItems = React.useMemo(() => satisTipiItems(), []);
    const satisTuruGridLookup = React.useMemo(() => allSatisTuruLookupItems(), []);
    const satisPaketGridLookup = React.useMemo(() => allSatisPaketLookupItems(), []);
    const isUcretsizRevizyon = isUcretsizRevizyonSatis(activeSatis?.CAS_SATIS_TURU, satisTuruFormItems);

    // Helper: field-level access control
    const getFieldReadOnly = useCallback((fieldLabel, fieldName) => {
        // Eğer satisReadOnly ise zaten readonly
        if (satisReadOnly) return true;
        // Eğer kullanıcı bu field'e özel olarak hak kısıtlaması var ise, readonly yap
        return utl.hasFieldRight(`CARISATIS Giremez>>${fieldLabel}>>${fieldName}`);
    }, [satisReadOnly]);

    // Helper: field-level required control
    const getIsFieldRequired = useCallback((fieldLabel, fieldName) => {
        return utl.hasFieldRight(`CARISATIS Zorunlu>>${fieldLabel}>>${fieldName}`);
    }, []);

    const screenArr = filterArray(glb.default.EKRANLkp, x => x.EKR_EKRANADI === 'carisatis');
    if (!screenArr || screenArr.length === 0) {
        notify(Dict.get('NotAuthThisScreen'), 'error');
    }
    const screen = {
        ...((screenArr && screenArr.length > 0) ? screenArr[0] : {}),
        EKR_EKRANADI: 'carisatis',
        EKLE: true,
        DUZELT: true,
        SIL: true,
    };

    const satisDataChanged = useRef(false);

    const SatisListGridRef = useRef(null);
    const popupForm = useRef(null);
    const rootScrollContainerRef = useRef(null);

    const formSatisList = useRef([]);
    const oldActiveSatisRef = useRef(null);
    const [satisList, setSatisList] = useState([]);
    const [benzerCariList, setBenzerCariList] = useState([]);
    const [paraRefreshToken, setParaRefreshToken] = useState(0);
    const [islemRefreshToken, setIslemRefreshToken] = useState(0);
    const [sablonRequest, setSablonRequest] = useState(null);
    const consumeSablonRequest = useCallback(() => setSablonRequest(null), []);
    useEffect(() => {
        setSablonRequest((request) => request && Number(request.casRef) !== Number(activeSatis?.CAS_REF) ? null : request);
    }, [activeSatis?.CAS_REF]);
    const [openPanels, setOpenPanels] = useState({
        islem: true,
        para: true,
        resim: true,
        ekim: true,
    });
    const [odemeSekliUserSelected, setOdemeSekliUserSelected] = useState(false);
    const [satisSaving, setSatisSaving] = useState(false);
    const satisSavingRef = useRef(false);
    const activeSatisRef = useRef(null);
    const isEmbedded = props.embedded === true || props.inTabMode === true;
    const formSatisRef = useRef(null);
    const isMountedRef = useRef(true);
    // Lazy-load kontrolü: popup açılınca yükle, kapanınca sıfırla
    const hasLoadedRef = useRef(false);
    const lastLoadedCarRefRef = useRef(null);
    const lastRefreshTokenRef = useRef(null);
    // Mount/unmount guard
    useEffect(() => {
        isMountedRef.current = true;
        return () => { isMountedRef.current = false; };
    }, []);

    useEffect(() => {
        const cleanup = enableGridWheelOuterScroll(rootScrollContainerRef.current);
        return cleanup;
    }, []);

    activeSatisRef.current = activeSatis;

    const togglePanel = useCallback((panelName) => {
        setOpenPanels((prev) => ({ ...prev, [panelName]: !prev[panelName] }));
    }, []);

    useEffect(() => {
        setOpenPanels({ islem: true, para: true, resim: true, ekim: true });
    }, [props.ops?.CAR_REF]);

    // Synchronization effect - listen for cari sync events
    useEffect(() => {
        const unsub = subscribeCariSync((evt) => {
            const carRef = props.ops?.CAR_REF;
            if (evt?.origin === 'carisatis') return;
            if (!carRef) return;
            if (Number(evt?.carRef) !== Number(carRef)) return;

            if (evt?.source === 'para') {
                if (evt?.paraSummary && evt?.casRef) {
                    const next = (Array.isArray(formSatisList.current) ? [...formSatisList.current] : []);
                    const idx = next.findIndex((r) => Number(r?.CAS_REF ?? r?.cas_ref) === Number(evt.casRef));
                    if (idx >= 0) {
                        next[idx] = {
                            ...next[idx],
                            ALACAK: Number(evt?.paraSummary?.ALACAK || 0),
                            TOPLAM_ALINAN: Number(evt?.paraSummary?.TOPLAM_ALINAN || 0),
                            KALAN: Number(evt?.paraSummary?.KALAN || 0)
                        };
                        formSatisList.current = next;
                        setSatisList(next);
                        if (props.ops?.CAR_REF) setCached(carRefCacheKey('SATIS_LST', props.ops.CAR_REF), next);
                    }
                }
                const hasParaPayload = Number(evt?.casRef) === Number(activeSatisRef.current?.CAS_REF) && Array.isArray(evt?.paraCasList);
                if (!hasParaPayload) {
                    setParaRefreshToken((v) => v + 1);
                }
            }
            if (evt?.source === 'islem') {
                const casRef = evt?.casRef;
                if (casRef) clearCached(casRefCacheKey('ISLEMLIST', casRef));
                // İşlem değişikliği geldiğinde, aktif satışa aitse her durumda refresh tetikle.
                // (Payload gelse bile IslemPanel bazen state'i kaçırabiliyor; token ile garantile.)
                if (!casRef || Number(casRef) === Number(activeSatisRef.current?.CAS_REF)) {
                    setIslemRefreshToken((v) => v + 1);
                }
            }

            // Satış listesi değiştiyse payload varsa direkt uygula, yoksa fallback GET
            if (evt?.source === 'satis') {
                if (Array.isArray(evt?.satisList)) {
                    const norm = sortSatisRowsByRefDesc(normalizeListToUpper(evt.satisList));
                    formSatisList.current = norm;
                    setSatisList(norm);
                    if (props.ops?.CAR_REF) setCached(carRefCacheKey('SATIS_LST', props.ops.CAR_REF), norm);
                    if (norm.length > 0) {
                        const preferred = Number(activeSatisRef.current?.CAS_REF || evt?.casRef || 0);
                        const selected = preferred > 0
                            ? (norm.find((x) => Number(x.CAS_REF ?? x.cas_ref) === preferred) || norm[0])
                            : norm[0];
                        setActiveSatis(selected);
                    } else {
                        setActiveSatis({ CAS_REF: -1 });
                    }
                    return;
                }
                hasLoadedRef.current = false;
                lastLoadedCarRefRef.current = null;
                lastRefreshTokenRef.current = null;
                if (carRef) clearCached(carRefCacheKey('SATIS_LST', carRef));
                getListFormData(carRef, activeSatisRef.current?.CAS_REF);
            }
        });
        return () => unsub();
    }, [props.ops?.CAR_REF]);

    // Sadece popup görünürken ve henüz yüklenmemişse ya da CAR_REF değişmişse veri çek
    useEffect(() => {
        if (!screen) return;
        const carRef = props.ops?.CAR_REF;
        const token = props.refreshToken ?? 0;
        if (props.formShow) {
            const shouldReload =
                !hasLoadedRef.current ||
                lastLoadedCarRefRef.current !== carRef ||
                lastRefreshTokenRef.current !== token;
            if (shouldReload) {
                getListFormData(carRef, props.ops?.CAS_REF);
                hasLoadedRef.current = true;
                lastLoadedCarRefRef.current = carRef;
                lastRefreshTokenRef.current = token;
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.formShow, props.ops?.CAR_REF, props.refreshToken]);

    // activeSatis değiştiğinde satistipi/satistipigrubu'yu CAS_TIP'ten senkronize et
    // Kayıt sonrası, ekran girişinde, grid satır değişiminde lookuplar (Satış Türü, Satış Paketi) doğru dolsun
    useEffect(() => {
        const casTip = activeSatis?.CAS_TIP;
        if (casTip != null && isKnownCasTip(casTip)) {
            syncLookupsFromCasTip(casTip);
        } else if (activeSatis?.CAS_REF === -1) {
            setSatistipi(-1);
            setSatistipigrubu(-1);
        }
    }, [activeSatis?.CAS_TIP, activeSatis?.CAS_REF, syncLookupsFromCasTip]);

    /** lst artık tam CAS satırı (+ ALACAK/KALAN) döndürür; sadece eksik form alanında /rec gerekir */
    const satisLstRowIsFull = (row) => {
        if (!row) return false;
        return Object.prototype.hasOwnProperty.call(row, 'CAS_SATIS_TUT')
            || Object.prototype.hasOwnProperty.call(row, 'CAS_ACENTA_TUT')
            || Object.prototype.hasOwnProperty.call(row, 'CAS_HAVA_ALANI');
    };

    const fetchFullSatisRec = useCallback((casRef, onSuccess) => {
        if (!casRef || casRef <= 0) return;
        Axios.get(`${process.env.REACT_APP_BACKEND_SERVER}CARI_SATIS/rec?CAS_REF=${casRef}`)
            .then(res => {
                if (!isMountedRef.current) return;
                const raw = Array.isArray(res.data) ? res.data[0] : (res.data?.cariSatis ?? res.data);
                if (!raw) return;
                const full = normalizeKeysToUpper(raw);
                setActiveSatis(full);
                const lst = formSatisList.current || [];
                const idx = lst.findIndex(r => Number(r?.CAS_REF ?? r?.cas_ref) === Number(casRef));
                if (idx >= 0) {
                    const nl = [...lst];
                    nl[idx] = { ...(nl[idx] || {}), ...full };
                    formSatisList.current = nl;
                    setSatisList(nl);
                    if (props.ops?.CAR_REF) setCached(carRefCacheKey('SATIS_LST', props.ops.CAR_REF), nl);
                }
                if (typeof onSuccess === 'function') onSuccess(full);
            })
            .catch(err => {
                if (!isMountedRef.current) return;
                notify(Dict.get('serverError') + (err?.message || ''), 'error');
            });
    }, [props.ops?.CAR_REF]);

    const getListFormData = async (carRef, preferredCasRef = null, forceReload = false) => {
        if (carRef == null || !cariKayitliMi(carRef)) return;
        const cacheKey = carRefCacheKey('SATIS_LST', carRef);
        if (forceReload) {
            clearCached(cacheKey);
        } else if (!getCached(cacheKey)) {
            try {
                await ensureEntityBundleCached('cari', carRef);
            } catch (_) { /* liste endpoint fallback */ }
        }
        const cached = forceReload ? null : getCached(cacheKey);
        if (!cached) {
            formSatisList.current = [];
            setSatisList([]);
            satisDataChanged.current = false;
        }
        getCachedOrFetch(cacheKey, async () => {
            const res = await Axios.get(`${process.env.REACT_APP_BACKEND_SERVER}CARI_SATIS/lst?CAR_REF=${carRef}`);
            return Array.isArray(res?.data) ? res.data : [];
        })
            .then((listData) => {
                if (!isMountedRef.current) return; // Component unmount olduysa setState yapma
                const norm = sortSatisRowsByRefDesc(normalizeListToUpper(Array.isArray(listData) ? listData : []));
                formSatisList.current = norm;
                setSatisList(norm);
                satisDataChanged.current = false;
                if (norm.length > 0) {
                    const preferred = Number(preferredCasRef || activeSatisRef.current?.CAS_REF || 0);
                    const selected = preferred > 0
                        ? (norm.find((x) => Number(x.CAS_REF ?? x.cas_ref) === preferred) || norm[0])
                        : norm[0];
                    const selectedCasRef = selected.CAS_REF ?? selected.cas_ref;
                    if (selectedCasRef && selectedCasRef > 0 && !satisLstRowIsFull(selected)) {
                        fetchFullSatisRec(selectedCasRef);
                    } else {
                        setActiveSatis(selected);
                    }
                } else {
                    setActiveSatis({ CAS_REF: -1 });
                }
                setFormShow(true);
                setSatisReadOnly(true);

                const shouldCheckSimilar =
                    (props.ops?.BENZER_VAR === true) ||
                    !!props.ops?.CAR_TEL1 ||
                    !!props.ops?.CAR_GSM ||
                    !!props.ops?.CAR_ADSOY;
                if (shouldCheckSimilar) {
                    loadBenzerCariList();
                } else {
                    setBenzerCariList([]);
                }
            })
            .catch(() => {
                if (!isMountedRef.current) return;
                notify(Dict.get('serverError'), 'error');
            });
    };

    const loadBenzerCariList = () => {
        if (!props.ops?.CAR_REF) {
            setBenzerCariList([]);
            return;
        }
        const params = {
            CAR_REF: props.ops?.CAR_REF,
            CAR_TEL1: props.ops?.CAR_TEL1 || '',
            CAR_GSM: props.ops?.CAR_GSM || '',
            CAR_ADSOY: props.ops?.CAR_ADSOY || ''
        };
        const suffix = `${params.CAR_TEL1}_${params.CAR_GSM}_${String(params.CAR_ADSOY || '').slice(0, 30)}_ds`;
        const cacheKey = carRefCacheKey('BENZERCARI', props.ops?.CAR_REF, suffix);
        getCachedOrFetch(cacheKey, async () => {
            const res = await Axios.get(`${process.env.REACT_APP_BACKEND_SERVER}CARI_KART/benzercari`, { params });
            return Array.isArray(res?.data) ? res.data : [];
        })
            .then((list) => {
                if (!isMountedRef.current) return;
                setBenzerCariList(Array.isArray(list) ? list : []);
            })
            .catch((err) => {
                if (!isMountedRef.current) return;
                console.error('Benzer cari yüklenemedi:', err);
                setBenzerCariList([]);
            });
    };

    const formValidate = () => {
        const res = formSatisRef.current.instance.validate();
        if (res.brokenRules.length > 0) {
            const firstRule = res.brokenRules[0] || {};
            const fieldName = firstRule?.validator?._validationInfo?.name || firstRule?.column?.caption || '';
            const ruleMsg = firstRule?.message || '';
            const msg = ruleMsg || (fieldName ? `${fieldName} alanı zorunludur.` : Dict.get('Eksik alanları doldurunuz'));
            notify(msg, 'warning');
            return false;
        }

        const satisTutar = Number(activeSatis?.CAS_SATIS_TUT) || 0;
        const odemeSekli = activeSatis?.CAS_ODE_SEKLI;
        if (!isUcretsizRevizyon && satisTutar <= 0) {
            notify('Anlaşma Tutarı zorunludur.', 'warning');
            return false;
        }
        if (!isUcretsizRevizyon && (odemeSekli === null || typeof odemeSekli === 'undefined' || odemeSekli === '')) {
            notify('Anlaşma Şekli zorunludur.', 'warning');
            return false;
        }
        const isNewSatis = Number(activeSatis?.CAS_REF) === -1 || !activeSatis?.CAS_REF;
        if (!isUcretsizRevizyon && satisTutar > 0 && isNewSatis && !odemeSekliUserSelected) {
            notify('Ödeme Türünü kullanıcı seçmelidir. Varsayılan seçimle kayıt yapılamaz.', 'warning');
            return false;
        }
        const satisActor = Number(glb.default?.KULLANICI?.KUL_REF || 0);
        const satisOwner = Number(props.ops?.CAR_ARA_KUL_REF || props.ops?.CAR_GIR_KUL_REF || 0);
        const satisGeneral = Number(glb.default?.KULLANICI?.KUL_YETKI) === 0
            || Number(glb.default?.KULLANICI?.KUL_YS) === 0
            || !!glb.default?.KULLANICI?.KUL_ISADMIN;
        const previousYapan = (satisList || []).find((row) => Number(row?.CAS_REF) === Number(activeSatis?.CAS_REF))?.CAS_GIR_KUL;
        if (!canAssignSatisYapan({
            currentUser: satisActor,
            dataOwner: satisOwner,
            isGeneralAuth: satisGeneral,
        }, activeSatis?.CAS_GIR_KUL, isNewSatis ? null : previousYapan)) {
            notify('Satış yapan kişi yalnız siz veya data sahibi olabilir.', 'warning', 3000);
            return false;
        }
        return true;
    };

    const formHiding = () => {
        setSablonRequest(null);
        formSatisList.current = [];
        if (props.onFormKapandi) props.onFormKapandi();
        setFormShow(false);
        hasLoadedRef.current = false;
        lastLoadedCarRefRef.current = null;
        lastRefreshTokenRef.current = null;
    };

    const handleBenzerCariClick = (e) => {
        if (!e.data) return;
        const clickedCari = e.data;
        // Parent component'e bildir (carikart.js bunu dinleyecek ve o cariyi yükleyecek)
        if (props.onBenzerCariClick) {
            props.onBenzerCariClick(clickedCari);
        }
        // Bu popup'u kapat, parent yeni cariyi yükleyecek ve popup tekrar açılacak
        formHiding();
    };

    const satisFieldDataChanged = (e) => {
        satisDataChanged.current = true;
        setActiveSatis((current) => current
            ? { ...current, [e.dataField]: e.value }
            : current);
    };

    const handleSatisKaydet = async () => {
        if (satisSavingRef.current) return;
        if (!satisDataChanged.current) { notify(Dict.get('Değişiklik Bulunamadı'), 'error'); return; }
        if (!formValidate()) return;
        satisSavingRef.current = true;
        setSatisSaving(true);
        const savePayload = normalizeUcretsizRevizyonPayload(activeSatis, satisTuruFormItems);
        const previousSatis = activeSatis.CAS_REF === -1 ? null : (oldActiveSatisRef.current || activeSatis);
        await Axios.post(`${process.env.REACT_APP_BACKEND_SERVER}CARI_SATIS/satiskaydet?cid=${glb.default.KULLANICI.KUL_DEF_FIR_REF}`, savePayload)
            .then(async (res) => {
                if (!isMountedRef.current) return;
                if (res.data.iserr === true) {
                    notify(Dict.get('serverError') + res.data.errmsg, 'error');
                } else {
                    const saved = normalizeKeysToUpper(res.data.saved) || res.data.saved;
                    const currentRows = formSatisList.current || [];
                    const updateIdx = currentRows.findIndex((row) => Number(row.CAS_REF) === Number(saved.CAS_REF));
                    const nl = [...currentRows];
                    // Ekrandaki sıralama indeksi veri dizisinin sırası olmayabilir.
                    if (updateIdx >= 0) nl[updateIdx] = { ...currentRows[updateIdx], ...saved };
                    else nl.unshift(saved);
                    formSatisList.current = nl;
                    setSatisList(nl);
                    setSatisReadOnly(true);
                    setActiveSatis(saved);
                    formSatisRef.current?.instance?.option('formData', saved);
                    SatisListGridRef.current?.instance?.repaintRows?.([
                        SatisListGridRef.current?.instance?.option('focusedRowIndex')
                    ].filter((x) => Number.isInteger(x) && x >= 0));
                    // Cache'i güncel saved veriyle güncelle
                    if (props.ops?.CAR_REF && nl) {
                        setCached(carRefCacheKey('SATIS_LST', props.ops.CAR_REF), nl);
                    }
                    // Anlaşma para satırı backend'de otomatik senkronlanır.
                    // Para paneli + arama paneli para kaynakları anlık yenilensin
                    const autoAgreement = res?.data?.autoAgreement || null;
                    clearCached(casRefCacheKey('PARALIST', saved.CAS_REF));
                    clearCached(carRefCacheKey('PARA_LIST_BY_CAR', props.ops?.CAR_REF));
                    const prevTedavi = oldActiveSatisRef.current?.CAS_GIR_TAR ?? oldActiveSatisRef.current?.cas_gir_tar;
                    const newTedavi = saved?.CAS_GIR_TAR ?? saved?.cas_gir_tar;
                    const tedaviChanged = !sameCalendarDay(prevTedavi, newTedavi);
                    emitCariSync({
                        carRef: props.ops?.CAR_REF,
                        casRef: saved?.CAS_REF,
                        source: 'satis',
                        origin: 'carisatis',
                        satisList: nl,
                        savedSatis: saved,
                        autoAgreement,
                        ...(tedaviChanged && Number(saved?.CAS_REF) > 0 ? { tedaviTarihRecalc: newTedavi } : {}),
                    });
                    oldActiveSatisRef.current = null;
                    satisDataChanged.current = false;
                    if (shouldOfferSatisSablon(previousSatis, saved)) {
                        setSablonRequest({ casRef: saved.CAS_REF });
                        setOpenPanels((current) => ({ ...current, islem: true }));
                    }
                }
            }).catch(err => {
                if (!isMountedRef.current) return;
                const status = err?.response?.status;
                notify(status === 504
                    ? 'Satış kaydı zaman aşımına uğradı ve başarı onayı alınamadı. Kayıt listesini yenileyip kontrol ediniz.'
                    : Dict.get('serverError') + (err?.response?.data?.message || err?.message || err), 'error', 5000);
            }).finally(() => {
                satisSavingRef.current = false;
                if (isMountedRef.current) setSatisSaving(false);
            });
    };

    const handleYeniSatis = () => {
        satisDataChanged.current = true;
        setOdemeSekliUserSelected(false);
        SatisListGridRef.current?.instance?.option('focusedRowIndex', -1);
        setActiveSatis({
            CAS_REF: -1, CAS_TIP: null, CAS_CAR_REF: props.ops.CAR_REF, CAS_SATIS_TURU: null,
            CAS_SAT_PAKET_REF: null, CAS_SATIS_TUT: 0, CAS_KAPORA_TUT: 0, CAS_ACENTA_TUT: 0, CAS_KALAN_TUT: 0,
            CAS_EKILEN_GREFT: 0, CAS_SAKAL_GREFT: 0, CAS_TOP_GREFT: 0, CAS_ODE_SEKLI: null, CAS_KON_REF: null,
            CAS_CFG_REF: latestMetaFormRef(formGelisler),
            CAS_SIL: false, CAS_SATIS_TUT_TAR: new Date(), CAS_GIR_TAR: new Date().toISOString('tr-TR', { timeZone: 'Europe/Istanbul', hour12: false }), CAS_GIR_KUL: glb.default.KULLANICI.KUL_REF
        });
        setFormShow(true);
        setSatisReadOnly(false);
    };

    const handleSatisDuzenle = () => {
        if (!canDeleteByOwner(glb.default?.KULLANICI, satisIsYapanRef(activeSatis))) {
            notify(FOREIGN_DELETE_MESSAGE, 'warning', 3000);
            return;
        }
        oldActiveSatisRef.current = activeSatis ? { ...activeSatis } : null;
        setSatisReadOnly(false);
    };

    const handleSatisYenile = () => {
        const carRef = props.ops?.CAR_REF;
        if (!cariKayitliMi(carRef)) return;
        getListFormData(carRef, activeSatisRef.current?.CAS_REF, true);
        setSatisReadOnly(true);
    };

    const handleVazgec = () => {
        if (activeSatis && activeSatis.CAS_REF === -1) {
            if (satisList && satisList.length > 0) {
                SatisListGridRef.current?.instance?.option('focusedRowIndex', 0);
                const idx = SatisListGridRef.current?.instance?.option('focusedRowIndex');
                setActiveSatis(satisList[idx]);
                setSatisReadOnly(true);
            } else {
                setActiveSatis(null); setSatisReadOnly(true);
            }
        } else {
            if (oldActiveSatisRef.current && oldActiveSatisRef.current.CAS_REF > 0) {
                setActiveSatis(oldActiveSatisRef.current);
                const rowIndex = (satisList || []).findIndex(x => x.CAS_REF === oldActiveSatisRef.current.CAS_REF);
                if (rowIndex >= 0) {
                    SatisListGridRef.current?.instance?.option('focusedRowIndex', rowIndex);
                }
                setSatisReadOnly(true);
                oldActiveSatisRef.current = null;
                return;
            }
            Axios.get(`${process.env.REACT_APP_BACKEND_SERVER}CARI_SATIS/rec?CAS_REF=${activeSatis.CAS_REF}`)
                .then(res => {
                    if (!isMountedRef.current) return;
                    if (res.data?.iserr === true) {
                        notify(Dict.get('serverError') + (res.data.errmsg || ''), 'error');
                    } else {
                        const raw = Array.isArray(res.data) ? res.data[0] : (res.data?.cariSatis ?? res.data);
                        const full = raw ? normalizeKeysToUpper(raw) : null;
                        if (full) {
                            const idx = SatisListGridRef.current?.instance?.option('focusedRowIndex');
                            if (typeof idx === 'number' && idx >= 0) {
                                const upd = [...(formSatisList.current || [])];
                                upd[idx] = { ...(upd[idx] || {}), ...full };
                                setSatisList(upd);
                                formSatisList.current = upd;
                                if (props.ops?.CAR_REF) setCached(carRefCacheKey('SATIS_LST', props.ops.CAR_REF), upd);
                            }
                            setActiveSatis(full);
                        }
                        setSatisReadOnly(true);
                    }
                    SatisListGridRef.current?.instance?.refresh();
                }).catch(err => {
                    if (!isMountedRef.current) return;
                    notify(Dict.get('serverError') + err, 'error');
                });
        }
    };

    const satisGridHeight = useMemo(
        () => gridHeightByRowCount((satisList || []).length, gridMaxHeightForRows(5)),
        [satisList]
    );

    if (actionType === 1 || !screen) return <Redirect to="/" />;

    if (!cariKayitliMi(props.ops?.CAR_REF)) {
        const uyariContent = <MasterKayitGerekliUyari carRef={props.ops?.CAR_REF} sekmeAdi="Satış" icon="📊" />;
        if (isEmbedded) {
            return <div style={{ width: '100%', height: '100%', overflow: 'auto', padding: 12 }}>{uyariContent}</div>;
        }
        return (
            <React.Fragment>
                <Popup id="infoForm" width={screen ? screen.EKR_GENISLIK + '%' : '80%'} height={screen ? screen.EKR_YUKSEKLIK + '%' : '80%'}
                    shading={false} dragEnabled={true} ref={popupForm}
                    closeOnOutsideClick={false} animation={null} showTitle={true} showCloseButton={true}
                    onHiding={formHiding} visible={props.formShow && formShow}
                    toolbarItems={[{ location: 'center', widget: 'dxTextBox', options: { text: 'SATIŞ - ' + (props.ops?.CAR_REF || '') + ':' + (props.ops?.CAR_ADSOY || '') + ' - ' + Dict.get('Kayıt Eklenemez'), readOnly: true, width: 400, height: 30, textAlign: 'center' } }, { location: 'after', widget: 'dxButton', options: { text: Dict.get('Çıkış'), type: 'default', onClick: formHiding, hint: Dict.get('Çıkış'), icon: 'close' } }]}
                >
                    <Position my="center" at="center" of={window} />
                    {uyariContent}
                </Popup>
            </React.Fragment>
        );
    }

    const satisActorRef = Number(glb.default?.KULLANICI?.KUL_REF || 0);
    const satisOwnerRef = Number(props.ops?.CAR_ARA_KUL_REF || props.ops?.CAR_GIR_KUL_REF || 0);
    const satisYapanRefs = allowedSatisYapanRefs({
        currentUser: satisActorRef,
        dataOwner: satisOwnerRef,
        isGeneralAuth: Number(glb.default?.KULLANICI?.KUL_YETKI) === 0
            || Number(glb.default?.KULLANICI?.KUL_YS) === 0
            || !!glb.default?.KULLANICI?.KUL_ISADMIN,
    });
    const satisYapanUsers = satisYapanRefs == null ? [] : satisYapanRefs.map((ref) => {
        const known = asArray(glb.default.KULLANICILkp).find((user) => Number(user?.KUL_REF) === ref);
        if (known) return known;
        return { KUL_REF: ref, KUL_ADI: ref === satisActorRef ? 'Siz' : 'Data Sahibi' };
    });
    const satisSubtitle = (props.ops?.CAR_ARA_KUL_REF === glb.default.KULLANICI.KUL_REF || props.ops?.CAR_ARA_KUL_REF === 0)
        ? Dict.get('Kendi MÜŞTERİN')
        : (glb.default.KULLANICI.KUL_YETKI === 0 ? Dict.get('Başkasının MÜŞTERİSİ (Kullanıcı:Genel Yetk.)') : Dict.get('Başkasının MÜŞTERİSİ'));
    const satisHeaderButtons = (
        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
            {screen && screen.EKLE && !satisReadOnly && <Button text={satisSaving ? 'Kaydediliyor…' : Dict.get('Satış Kaydet')} type="success" disabled={satisSaving} onClick={handleSatisKaydet} />}
            {screen && screen.EKLE && satisReadOnly && <Button text={Dict.get('Yeni Satış')} type="default" onClick={handleYeniSatis} />}
            {screen && screen.EKLE && satisList && satisList.length > 0 && satisReadOnly && activeSatis && activeSatis.CAS_REF > 0
                && canDeleteByOwner(glb.default?.KULLANICI, satisIsYapanRef(activeSatis)) && <Button text={Dict.get('Satış Düzenle')} type="success" onClick={handleSatisDuzenle} />}
            {satisReadOnly && activeSatis && Number(activeSatis.CAS_REF) > 0
                && canDeleteByOwner(glb.default?.KULLANICI, satisIsYapanRef(activeSatis)) && (
                <Button text="Satış Sil" type="danger" onClick={async () => {
                    if (!window.confirm('Bu satış kaydı silinsin mi?')) return;
                    try {
                        await Axios.post(`${process.env.REACT_APP_BACKEND_SERVER}CARI_SATIS/satissil`, {
                            CAS_REF: activeSatis.CAS_REF,
                            CAR_REF: props.ops?.CAR_REF,
                            kulid: glb.default.KULLANICI.KUL_REF,
                        });
                        notify('Satış silindi.', 'success', 2000);
                        handleSatisYenile();
                    } catch (err) {
                        notify(err?.response?.data?.errmsg || FOREIGN_DELETE_MESSAGE, 'error', 3000);
                    }
                }} />
            )}
            {screen && satisReadOnly && <Button text={Dict.get('Yenile')} type="default" onClick={handleSatisYenile} />}
            {screen && screen.EKLE && !satisReadOnly && <Button text={Dict.get('Vazgeç')} type="warning" onClick={handleVazgec} />}
        </div>
    );

    const toolbarItemsForPopup = [
        { location: 'center', widget: 'dxTextBox', options: { text: 'SATIŞ - ' + (props.ops?.CAR_REF || '') + ':' + (props.ops?.CAR_ADSOY || '') + '  (' + satisSubtitle + ')', readOnly: true, width: 400, height: 30, textAlign: 'center' } },
        { location: 'after', widget: 'dxButton', options: { text: Dict.get('Çıkış'), type: 'default', onClick: formHiding, hint: Dict.get('Çıkış'), icon: 'close' } }
    ];

    const mainContent = (
        <div ref={rootScrollContainerRef} style={{ width: '100%', height: '100%' }}>
                {/*
                  Grid yükseklikleri: paging kapalı, hedef görünür satır sayısı.
                  Amaç: scroll ile devam, ekranda "yaklaşık N satır" görünsün.
                */}
                {(() => { /* no-op IIFE for local consts */ return null; })()}
                {/* Benzer Cari Grid - sadece BENZER_VAR true ise göster */}
                {props.ops?.BENZER_VAR === true && benzerCariList && benzerCariList.length > 0 && (
                    <div style={{
                        marginBottom: '12px',
                        padding: '12px',
                        background: '#0bd008ff',
                        border: '2px solid #0a0300ff',
                        borderRadius: '6px'
                    }}>
                        <h4 style={{
                            margin: '0 0 8px 0',
                            fontSize: '14px',
                            fontWeight: 600,
                            color: '#031a77ff'
                        }}>
                            ⚠️ Benzer Cariler Bulundu ({benzerCariList.length})
                        </h4>
                        <DataGrid
                            dataSource={benzerCariList}
                            showBorders={true}
                            keyExpr="CAR_REF"
                            height={80}
                            columnAutoWidth={false}
                            columnMinWidth={120}
                            hoverStateEnabled={true}
                            onRowClick={handleBenzerCariClick}>
                            <Selection mode="single" />
                            <Scrolling mode="standard" useNative={false} showScrollbar="always" columnRenderingMode="standard" />
                            <LoadPanel enabled={true} />
                            <Column dataField="CAR_REF" caption={Dict.get('id')} width={80} />
                            <Column dataField="CAR_ADSOY" caption={Dict.get('Ad Soyad')} />
                            <Column dataField="DATA_SAHIBI" caption="Data Sahibi" width={140} />
                            <Column dataField="CAR_GSM" caption={Dict.get('GSM1')} width={120} />
                            <Column dataField="CAR_TEL1" caption={Dict.get('GSM2')} width={120} />
                            <Column dataField="CAR_CINSIYET" caption={Dict.get('Cinsiyet')} width={80} />
                            <Column dataField="ULKE_AD" caption={Dict.get('Ülke')} width={100} />
                            <Column dataField="SON_DEG" caption={Dict.get('Son Değerlendirme')} />
                            <Column dataField="SON_DURUM" caption={Dict.get('Son Durum')} />
                            <Column dataField="isactive" caption={Dict.get('isactive')} width={80} />
                        </DataGrid>
                    </div>
                )}

                <ScrollView id={'scrollview'} width='100%' height='100%'>
                    <Box direction="row" width="100%" height="100%">
                        <Item ratio={8}>
                            {/* Satış Listesi Bölümü */}
                            <div className="cari-form-compact" style={{
                                padding: '12px',
                                marginBottom: '12px',
                                background: 'var(--dx-color-bg-secondary, #f8f9fa)',
                                border: '1px solid var(--dx-color-border, #dee2e6)',
                                borderRadius: '4px'
                            }}>
                                <div style={{
                                    marginBottom: '8px',
                                    fontWeight: 'bold',
                                    fontSize: '14px',
                                    color: 'var(--dx-color-text, #212529)',
                                    borderBottom: '2px solid var(--dx-color-border, #dee2e6)',
                                    paddingBottom: '4px',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    flexWrap: 'wrap',
                                    gap: 8
                                }}>
                                    <span>📊 {Dict.get('Satış Kayıtları')}</span>
                                    {satisHeaderButtons}
                                </div>
                                <DataGrid className={'context dx-card wide-card'} dataSource={satisList} showBorders={true}
                                 keyExpr="CAS_REF" focusedRowEnabled={true} hoverStateEnabled={false} repaintChangesOnly={true} ref={SatisListGridRef}
                                  focusedRowKey={Number(activeSatis?.CAS_REF) > 0 ? Number(activeSatis.CAS_REF) : null}
                                  height={satisGridHeight} width={'100%'} columnAutoWidth={false} columnMinWidth={120} allowColumnResizing={true} onFocusedRowChanged={(e) => {
                                    const active = e.row?.data || null;
                                    // Düzenleme modunda satır değişiminde formu kilitleme; sadece readonly iken güncelle.
                                    if (!satisReadOnly) return;
                                    if (active) {
                                        satisDataChanged.current = false;
                                        // focusedRowKey controlled olduğu için seçimi anında state'e yansıt.
                                        setActiveSatis(active);
                                        const casRef = active.CAS_REF ?? active.cas_ref;
                                        // lst tam satır yoksa (eski cache) forma eksik alanlar için /rec
                                        if (casRef && casRef > 0 && !satisLstRowIsFull(active)) {
                                            fetchFullSatisRec(casRef);
                                        }
                                        setSatisReadOnly(true);
                                    }
                                }}>
                                    <Selection mode="single" selectAllMode="allPages" showCheckBoxesMode={true} />
                                    <Scrolling mode="standard" useNative={false} showScrollbar="always" columnRenderingMode="standard" />
                                    <LoadPanel enabled={true} />
                                    <Column dataField="CAS_REF" visible={true} caption={Dict.get('K.No')} />
                                    <Column
                                        dataField="CAS_CFG_REF"
                                        caption="Form Bilgisi"
                                        width={220}
                                        visible={showMetaFormSelect}
                                        cellRender={({ data }) => {
                                            const ref = data?.CAS_CFG_REF;
                                            const item = metaFormItems.find((x) => Number(x.CFG_REF) === Number(ref));
                                            return (
                                                <span className="meta-form-grid-cell">
                                                    {item?.META_FORM_LABEL || (ref ? `#${ref}` : '—')}
                                                </span>
                                            );
                                        }}
                                    />
                                    <Column dataField="CAS_TIP" caption={Dict.get('Satış Tipi')}>
                                        <Lookup dataSource={satisTipiGridItems} searchEnabled={true} searchMode='contains' displayExpr='ST_AD' searchExpr='ST_AD' valueExpr='ST_KODINT' />
                                    </Column>
                                    <Column dataField="CAS_SATIS_TURU" caption={Dict.get('Satış Türü')}>
                                        <Lookup dataSource={satisTuruGridLookup} searchEnabled={true} searchMode='contains' displayExpr='ST_AD' searchExpr='ST_AD' valueExpr='ST_REF' />
                                    </Column>
                                    <Column dataField="CAS_SAT_PAKET_REF" caption={Dict.get('Satış Paketi')}>
                                        <Lookup dataSource={satisPaketGridLookup} searchEnabled={true} searchMode='contains' displayExpr='ST_AD' searchExpr='ST_AD' valueExpr='ST_REF' />
                                    </Column>
                                    <Column dataField="CAS_SATIS_TUT_TAR" dataType="date" format="dd-MM-yyyy" caption={Dict.get('Satış Tarihi')} />
                                    <Column dataField="CAS_GIR_TAR" dataType="date" format="dd-MM-yyyy" caption={Dict.get('Tedavi Tarihi')} />
                                    <Column dataField="ALACAK" dataType="number" format="#,##0.00" caption={Dict.get('Alacak')} />
                                    <Column dataField="KALAN" dataType="number" format="#,##0.00" caption={Dict.get('Kalan')} />
                                </DataGrid>
                            </div>
                            <ErrorBoundary>
                                {/* Satış Formu Bölümü */}
                                <div className="cari-form-compact" style={{
                                    padding: '12px',
                                    marginBottom: '12px',
                                    background: 'var(--dx-color-bg-secondary, #f8f9fa)',
                                    border: '1px solid var(--dx-color-border, #dee2e6)',
                                    borderRadius: '4px'
                                }}>
                                    <div style={{
                                        marginBottom: '8px',
                                        fontWeight: 'bold',
                                        fontSize: '14px',
                                        color: 'var(--dx-color-text, #212529)',
                                        borderBottom: '2px solid var(--dx-color-border, #dee2e6)',
                                        paddingBottom: '4px'
                                    }}>
                                        📋 Satış Bilgileri
                                    </div>
                                    <Form ref={formSatisRef} formData={activeSatis || {}} showValidationSummary={true}
                                        labelLocation='left' colCount={1} scrollingEnabled={false} showColonAfterLabel={true}
                                        readOnly={satisReadOnly}
                                        hoverStateEnabled={false} onFieldDataChanged={satisFieldDataChanged}>
                                        {satisYapanRefs && (
                                            <SimpleItem dataField="CAS_GIR_KUL" colSpan={12} editorType="dxSelectBox" editorOptions={{
                                                readOnly: satisReadOnly,
                                                items: satisYapanUsers,
                                                searchEnabled: true,
                                                searchMode: 'contains',
                                                displayExpr: 'KUL_ADI',
                                                searchExpr: 'KUL_ADI',
                                                valueExpr: 'KUL_REF',
                                            }}>
                                                <RequiredRule message="Satış yapan kişi zorunludur." />
                                                <Label text="Satış Yapan" />
                                            </SimpleItem>
                                        )}
                                        <GroupItem colCount={12}>
                                            <SimpleItem dataField='CAS_TIP' colSpan={6} editorType='dxSelectBox'
                                                editorOptions={{
                                                    readOnly: getFieldReadOnly('Satış Tipi', 'CAS_TIP'),
                                                    items: satisTipiGridItems,
                                                    searchEnabled: true, searchMode: 'contains', displayExpr: 'ST_AD', searchExpr: 'ST_AD', valueExpr: 'ST_KODINT',
                                                    onValueChanged: (e) => {
                                                        syncLookupsFromCasTip(e.value);
                                                    }
                                                }}>
                                                {getIsFieldRequired('Satış Tipi', 'CAS_TIP') && <RequiredRule message={Dict.get('Satış Tipi') + ' ' + Dict.get('isRequired')} />}
                                                <Label text={Dict.get('Satış Tipi')}></Label>
                                            </SimpleItem>
                                            <SimpleItem dataField='CAS_SATIS_TURU' colSpan={6} editorType='dxSelectBox'
                                                editorOptions={{
                                                    readOnly: getFieldReadOnly('Satış Türü', 'CAS_SATIS_TURU'),
                                                    items: satisTuruFormItems,
                                                    searchEnabled: true, searchMode: 'contains', displayExpr: 'ST_AD', searchExpr: 'ST_AD', valueExpr: 'ST_REF'
                                                }}>
                                                {getIsFieldRequired('Satış Türü', 'CAS_SATIS_TURU') && <RequiredRule message={Dict.get('Satış Türü') + ' ' + Dict.get('isRequired')} />}
                                                <Label text={Dict.get('Satış Türü')}></Label>
                                            </SimpleItem>
                                        </GroupItem>
                                        <SimpleItem
                                            dataField="CAS_CFG_REF"
                                            editorType="dxSelectBox"
                                            visible={showMetaFormSelect}
                                            cssClass={META_FORM_FIELD_CLASS}
                                            editorOptions={{
                                                items: metaFormItems,
                                                displayExpr: 'META_FORM_LABEL',
                                                valueExpr: 'CFG_REF',
                                                searchEnabled: true,
                                                showClearButton: true,
                                                placeholder: 'Form bilgisi seçin',
                                                elementAttr: { class: META_FORM_EDITOR_CLASS },
                                            }}
                                        >
                                            <Label text="Form Bilgisi" />
                                        </SimpleItem>
                                        <GroupItem colCount={12}>
                                            <SimpleItem dataField='CAS_SAT_PAKET_REF' colSpan={12} editorType='dxSelectBox' editorOptions={{
                                                readOnly: getFieldReadOnly('Satış Paketi', 'CAS_SAT_PAKET_REF'),
                                                items: satisPaketFormItems,
                                                searchEnabled: true, searchMode: 'contains', displayExpr: 'ST_AD', searchExpr: 'ST_AD', valueExpr: 'ST_REF'
                                            }}>
                                                {getIsFieldRequired('Satış Paketi', 'CAS_SAT_PAKET_REF') && <RequiredRule message={Dict.get('Satış Paketi') + ' ' + Dict.get('isRequired')} />}
                                                <Label text={Dict.get('Satış Paketi')}></Label>
                                            </SimpleItem>

                                        </GroupItem>
                                        <GroupItem colCount={12} cssClass="satis-date-row">
                                            <SimpleItem dataField='CAS_SATIS_TUT_TAR' colSpan={5} text={Dict.get('Satış Tarihi')} editorType='dxDateBox'
                                                editorOptions={{
                                                    readOnly: getFieldReadOnly('Satış Tarihi', 'CAS_SATIS_TUT_TAR'),
                                                    onOpened: (e) => handleDateBoxOpened(e),
                                                }}>
                                                {getIsFieldRequired('Satış Tarihi', 'CAS_SATIS_TUT_TAR') && <RequiredRule message={Dict.get('Satış Tarihi') + ' ' + Dict.get('isRequired')} />}
                                                <Label text={Dict.get('Satış Tarihi')} />
                                            </SimpleItem>
                                            <SimpleItem dataField='CAS_GIR_TAR' colSpan={5} editorType='dxDateBox'
                                                editorOptions={{
                                                    readOnly: getFieldReadOnly('Tedavi Tarihi', 'CAS_GIR_TAR'),
                                                    onOpened: (e) => handleDateBoxOpened(e),
                                                }}>
                                                {getIsFieldRequired('Tedavi Tarihi', 'CAS_GIR_TAR') && <RequiredRule message={Dict.get('Tedavi Tarihi') + ' ' + Dict.get('isRequired')} />}
                                                <Label text={Dict.get('Tedavi Tarihi')} />
                                            </SimpleItem>
                                            <SimpleItem dataField='CAS_ACENTA_TUT' colSpan={2} text={Dict.get('Acente Tut.')} editorType='dxNumberBox' editorOptions={{ readOnly: getFieldReadOnly('Acente Tutarı', 'CAS_ACENTA_TUT'), format: '#,##0.00' }}>
                                                {getIsFieldRequired('Acente Tutarı', 'CAS_ACENTA_TUT') && <RequiredRule message={Dict.get('Acente Tutarı') + ' ' + Dict.get('isRequired')} />}
                                                <Label text={Dict.get('Acente Tutarı')} />
                                            </SimpleItem>

                                        </GroupItem>


                                        <GroupItem colCount={12} >
                                             <SimpleItem dataField='CAS_SATIS_TUT' colSpan={4} editorType='dxNumberBox'
                                             editorOptions={{
                                                readOnly: getFieldReadOnly('Anlaşma Tutarı', 'CAS_SATIS_TUT'),
                                                format: '#,##0.00'
                                            }}>
                                                {!isUcretsizRevizyon && <RequiredRule message={Dict.get('Anlaşma Tutarı') + ' ' + Dict.get('isRequired')} />}
                                                <Label text={Dict.get('Anlaşma Tutarı')} />
                                            </SimpleItem>
                                            <SimpleItem dataField='CAS_ODE_SEKLI' colSpan={4} editorType='dxSelectBox' editorOptions={{
                                                readOnly: getFieldReadOnly('Ödeme', 'CAS_ODE_SEKLI'),
                                                items: filterArray(glb.default.sabitLkp, x => x.ST_TUR === 122),
                                                searchEnabled: true, searchMode: 'contains', displayExpr: 'ST_AD', searchExpr: 'ST_AD', valueExpr: 'ST_KODINT',
                                                onValueChanged: (e) => {
                                                    setOdemeSekliUserSelected(true);
                                                }
                                            }}>
                                                {!isUcretsizRevizyon && <RequiredRule message={Dict.get('Anlaşma Şekli') + ' ' + Dict.get('isRequired')} />}
                                                <Label text={Dict.get('Anlaşma Şekli')} />
                                            </SimpleItem>
                                            <SimpleItem dataField="CAS_ACK" colSpan={12} cssClass="satis-ack-row" editorType="dxTextBox" editorOptions={{ readOnly: getFieldReadOnly('Açıklama', 'CAS_ACK') }}>
                                                <Label text={Dict.get('Açıklama')} />
                                            </SimpleItem>
                                            <SimpleItem dataField='CAS_EKILEN_GREFT' colSpan={4} editorType="dxNumberBox" visible={isEkimCasTip(satistipi)}
                                            editorOptions={{ readOnly: getFieldReadOnly('Donör Grefti', 'CAS_EKILEN_GREFT'), onValueChanged: (e) => { if (formSatisRef.current) { const dif = (e.value + (activeSatis?.CAS_SAKAL_GREFT || 0)); formSatisRef.current.instance.updateData('CAS_TOP_GREFT', dif); } }, format: '#,##0' }}>
                                                <Label text={Dict.get('Donör Grefti')} />
                                            </SimpleItem>
                                            <SimpleItem dataField='CAS_SAKAL_GREFT' colSpan={4} editorType="dxNumberBox" visible={isEkimCasTip(satistipi)}
                                             editorOptions={{ readOnly: getFieldReadOnly('Sakal Altı Gr.', 'CAS_SAKAL_GREFT'), onValueChanged: (e) => { if (formSatisRef.current) { const dif = (e.value + (activeSatis?.CAS_EKILEN_GREFT || 0)); formSatisRef.current.instance.updateData('CAS_TOP_GREFT', dif); } }, format: '#,##0' }}>
                                                <Label text={Dict.get('Sakal Altı Gr.')} />
                                            </SimpleItem>
                                           
                                            <SimpleItem dataField='CAS_TOP_GREFT' colSpan={4} editorType="dxNumberBox" visible={isEkimCasTip(satistipi)} 
                                            editorOptions={{ readOnly: true, format: '#,##0' }}>
                                                <Label text={Dict.get('Toplam')} />
                                            </SimpleItem>
                                            <SimpleItem dataField='CAS_KON_REF' colSpan={4} editorType='dxSelectBox' editorOptions={{ readOnly: getFieldReadOnly('Konaklama', 'CAS_KON_REF'), items: filterArray(glb.default.sabitLkp, x => x.ST_TUR === 9), searchEnabled: true, searchMode: 'contains', displayExpr: 'ST_AD', searchExpr: 'ST_AD', valueExpr: 'ST_REF' }}>
                                                {getIsFieldRequired('Konaklama', 'CAS_KON_REF') && <RequiredRule message={Dict.get('Konaklama') + ' ' + Dict.get('isRequired')} />}
                                                <Label text={Dict.get('Konaklama')}></Label>
                                            </SimpleItem>
                                            <SimpleItem dataField='CAS_KON_BAS_TAR' colSpan={4} editorType='dxDateBox' editorOptions={{ readOnly: getFieldReadOnly('Baş.Tar.', 'CAS_KON_BAS_TAR'), onOpened: (e) => handleDateBoxOpened(e) }}>
                                                {getIsFieldRequired('Baş.Tar.', 'CAS_KON_BAS_TAR') && <RequiredRule message={Dict.get('Baş.Tar.') + ' ' + Dict.get('isRequired')} />}
                                                <Label text={Dict.get('Baş.Tar.')} />
                                            </SimpleItem>
                                            <SimpleItem dataField='CAS_KON_BIT_TAR' colSpan={4} editorType='dxDateBox' editorOptions={{ readOnly: getFieldReadOnly('Bit.Tar.', 'CAS_KON_BIT_TAR'), onOpened: (e) => handleDateBoxOpened(e) }}>
                                                {getIsFieldRequired('Bit.Tar.', 'CAS_KON_BIT_TAR') && <RequiredRule message={Dict.get('Bit.Tar.') + ' ' + Dict.get('isRequired')} />}
                                                <Label text={Dict.get('Bit.Tar.')} />
                                            </SimpleItem>
                                            <SimpleItem dataField='CAS_ULKE_GIR_TAR' colSpan={4} editorType='dxDateBox' editorOptions={{ readOnly: getFieldReadOnly('Ulk.Gir.Tarihi', 'CAS_ULKE_GIR_TAR'), onOpened: (e) => handleDateBoxOpened(e) }}>
                                                {getIsFieldRequired('Ulk.Gir.Tarihi', 'CAS_ULKE_GIR_TAR') && <RequiredRule message={Dict.get('Ulk.Gir.Tarihi') + ' ' + Dict.get('isRequired')} />}
                                                <Label text={Dict.get('Ulk.Gir.Tarihi')} />
                                            </SimpleItem>
                                            <SimpleItem dataField='CAS_HAVA_ALANI' colSpan={4} editorType="dxTextBox" editorOptions={{ readOnly: getFieldReadOnly('Havaalanı', 'CAS_HAVA_ALANI') }}>
                                                {getIsFieldRequired('Havaalanı', 'CAS_HAVA_ALANI') && <RequiredRule message={Dict.get('Havaalanı') + ' ' + Dict.get('isRequired')} />}
                                                <Label text={Dict.get('Havaalanı')} />
                                            </SimpleItem>
                                            <SimpleItem dataField='CAS_HAVA_YOLU' colSpan={4} editorType="dxTextBox" editorOptions={{ readOnly: getFieldReadOnly('Havayolu', 'CAS_HAVA_YOLU') }}>
                                                {getIsFieldRequired('Havayolu', 'CAS_HAVA_YOLU') && <RequiredRule message={Dict.get('Havayolu') + ' ' + Dict.get('isRequired')} />}
                                                <Label text={Dict.get('Havayolu')} />
                                            </SimpleItem>
                                        </GroupItem>
                                    </Form>
                                </div>



                                {/* İşlemler Bölümü */}
                                <div style={{
                                    padding: '12px',
                                    marginBottom: '12px',
                                    background: 'var(--dx-color-bg-secondary, #f8f9fa)',
                                    border: '1px solid var(--dx-color-border, #dee2e6)',
                                    borderRadius: '4px'
                                }}>
                                    <Button
                                        text={`🔧 İşlemler ${openPanels.islem ? '▲' : '▼'}`}
                                        type="default"
                                        disabled={!(activeSatis && activeSatis.CAS_REF > 0)}
                                        onClick={() => togglePanel('islem')}
                                    />
                                    {shouldMountSalesPanel(openPanels, 'islem', activeSatis) && (
                                        <Suspense fallback={<div style={{ padding: 12 }}><LoadingElapsed text="İşlemler yükleniyor" /></div>}>
                                            <LazyIslemPanel
                                                key={activeSatis?.CAS_REF}
                                                islemReadOnly={false}
                                                carRef={props.ops.CAR_REF}
                                                casRef={activeSatis?.CAS_REF}
                                                satistipigrubu={satistipigrubu}
                                                satisTipi={activeSatis?.CAS_TIP ?? satistipi}
                                                satisTuru={activeSatis?.CAS_SATIS_TURU}
                                                sablonRequest={sablonRequest}
                                                onSablonRequestConsumed={consumeSablonRequest}
                                                islemRefreshToken={islemRefreshToken}
                                                gridVisibleRowCount={8}
                                            />
                                        </Suspense>
                                    )}
                                </div>

                              
                            </ErrorBoundary>

                        </Item>
                        <Item ratio={6}>
                            {/* Para + Resim + Ekim/Kanal Alım Bölümü (sağ kolon) */}
                            <div style={{
                                padding: '12px',
                                background: 'var(--dx-color-bg-secondary, #f8f9fa)',
                                border: '1px solid var(--dx-color-border, #dee2e6)',
                                borderRadius: '4px',
                                height: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '8px'
                            }}>
                                {/* Tahsilat (Para) Bölümü - sağda en üst */}
                                <div style={{
                                    padding: '12px',
                                    background: 'var(--dx-color-bg-secondary, #f8f9fa)',
                                    border: '1px solid var(--dx-color-border, #dee2e6)',
                                    borderRadius: '4px'
                                }}>
                                    <Button
                                        text={`💰 Tahsilat ${openPanels.para ? '▲' : '▼'}`}
                                        type="default"
                                        disabled={!(activeSatis && activeSatis.CAS_REF > 0)}
                                        onClick={() => togglePanel('para')}
                                    />
                                    {shouldMountSalesPanel(openPanels, 'para', activeSatis) && (
                                        <Suspense fallback={<div style={{ padding: 12 }}><LoadingElapsed text="Tahsilat yükleniyor" /></div>}>
                                            <LazyParaPanel
                                                paraReadOnly={false}
                                                carRef={props.ops.CAR_REF}
                                                casRef={activeSatis?.CAS_REF}
                                                satisTarihi={activeSatis?.CAS_SATIS_TUT_TAR || activeSatis?.CAS_GIR_TAR}
                                                dataSahibiKulRef={props.ops?.CAR_ARA_KUL_REF ?? null}
                                                refreshToken={paraRefreshToken}
                                                gridVisibleRowCount={5}
                                            />
                                        </Suspense>
                                    )}
                                </div>

                            </div>
                        </Item>
                    </Box>
                </ScrollView >
        </div>
    );

    if (isEmbedded) {
        return (
            <div style={{ width: '100%', height: '100%', overflow: 'auto', padding: 12 }}>
                {mainContent}
            </div>
        );
    }

    return (
        <React.Fragment>
            <Popup id="infoForm" width={screen ? screen.EKR_GENISLIK + '%' : '80%'} height={screen ? screen.EKR_YUKSEKLIK + '%' : '80%'}
                shading={false} dragEnabled={true} ref={popupForm}
                closeOnOutsideClick={false} animation={null} showTitle={true} showCloseButton={true}
                onHiding={formHiding} visible={props.formShow && formShow}
                toolbarItems={toolbarItemsForPopup}
            >
                <Position my="center" at="center" of={window} />
                {mainContent}
            </Popup>
        </React.Fragment>
    );
}
